$(function () {
    $('[data-calendar-filter]').each(function () {
        var $el = $(this);
        var myCalendar = null;
        var src = null;
        var $label = $('[data-calendar-filter-label]', $el);
        var from, to, fromSrc, toSrc;
        moment.locale($('html').attr('lang'));
        var paramsURL = new URLSearchParams(window.location.search);

        $('[data-calendar-filter-content]', $el).each(function () {
            myCalendar = jsCalendar.new(this, new Date(), {
                language: $('html').attr('lang')
            });
        });

        if (!myCalendar) {
            return;
        }

        myCalendar.onDateClick(function (event, date) {
            $el.removeClass('button-date-range--show-calendar');
            if (src === 'from') {
                setFrom(moment(date).format('YYYY-MM-DD'));
                if (moment(getFrom()) > moment(getTo())) {
                    setTo(moment(date).format('YYYY-MM-DD'));
                }
            } else {
                setTo(moment(date).format('YYYY-MM-DD'));
                if (moment(getFrom()) > moment(getTo())) {
                    setFrom(moment(date).format('YYYY-MM-DD'));
                }
            }
            updateValues();
        });

        $el.click(function (e) {
            e.stopPropagation();
            e.preventDefault();
        });

        $('[data-calendar-filter-opener]', $el).click(function (e) {
            e.stopPropagation();
            e.preventDefault();

            if (!$el.hasClass('is-open')) {
                closeAll();
            }
            $el.toggleClass('is-open');
        })

        $('[data-calendar-filter-action=from]').click(function () {
            $el.addClass('button-date-range--show-calendar');
            myCalendar.set(getFrom());
            src = 'from';
        });

        $('[data-calendar-filter-action=to]').click(function () {
            $el.addClass('button-date-range--show-calendar');
            myCalendar.set(getTo());
            src = 'to';
        });

        $('[data-calendar-filter-action=today]').click(function () {
            var today = moment();
            setFrom(today.format('YYYY-MM-DD'));
            setTo(today.format('YYYY-MM-DD'));
            updateValues();
        });

        $('[data-calendar-filter-action=yesterday]').click(function () {
            var yesterday = moment().subtract(1, 'days');
            setFrom(yesterday.format('YYYY-MM-DD'));
            setTo(yesterday.format('YYYY-MM-DD'));
            updateValues();
        });

        $('[data-calendar-filter-action=this_month]').click(function () {
            var today = moment();
            setFrom(today.startOf('month').format('YYYY-MM-DD'));
            setTo(today.endOf('month').format('YYYY-MM-DD'));
            updateValues();
        });

        $('[data-calendar-filter-action=last_month]').click(function () {
            var lastMonth = moment().subtract(1, 'months');
            setFrom(lastMonth.startOf('month').format('YYYY-MM-DD'));
            setTo(lastMonth.endOf('month').format('YYYY-MM-DD'));
            updateValues();
        });

        $('[data-calendar-filter-action=last_3_months]').click(function () {
            var today = moment();
            setTo(today.endOf('month').format('YYYY-MM-DD'));
            setFrom(today.subtract(3, 'months').startOf('month').format('YYYY-MM-DD'));
            updateValues();
        });

        $('[data-calendar-filter-action=filter]').click(function () {
            submit();
        });

        $('html, body').click(function () {
            closeAll();
        });

        $(document).keyup(function (e) {
            if (e.keyCode === 27) {
                if ($el.hasClass('button-date-range--show-calendar')) {
                    $el.removeClass('button-date-range--show-calendar');
                } else if ($el.hasClass('is-open')) {
                    $el.removeClass('is-open');
                }
            }
            if (e.keyCode === 13) {
                submit();
            }
        });

        function getFrom() {
            return new Date(from);
        }

        function getTo() {
            return new Date(to);
        }

        // function getFromStr() {
        //     return $('[data-calendar-filter-action-value=from]', $el).val();
        // }

        // function getToStr() {
        //     return $('[data-calendar-filter-action-value=to]', $el).val();
        // }

        function setFrom(value) {
            // $('[data-calendar-filter-action-value=from]', $el).val(value);
            from = value;
        }

        function setTo(value) {
            // $('[data-calendar-filter-action-value=to]', $el).val(value);
            to = value;
        }

        function closeAll() {
            $el.removeClass('button-date-range--show-calendar');
            $el.removeClass('is-open');

            to = toSrc;
            from = fromSrc;
            updateValues();
        }

        function isToday() {
            var today = moment();
            return toSrc === today.format('YYYY-MM-DD') &&
                fromSrc === today.format('YYYY-MM-DD');
        }

        function willBeToday() {
            var today = moment();
            return to === today.format('YYYY-MM-DD') &&
                from === today.format('YYYY-MM-DD');
        }

        function isYesterday() {
            var yesterday = moment().subtract(1, 'days');
            return toSrc === yesterday.format('YYYY-MM-DD') &&
                fromSrc === yesterday.format('YYYY-MM-DD');
        }

        function isSameDay() {
            return toSrc === fromSrc;
        }

        function isThisMonth() {
            var today = moment();
            return toSrc === today.endOf('month').format('YYYY-MM-DD') &&
                fromSrc === today.startOf('month').format('YYYY-MM-DD');
        }

        function isLastMonth() {
            var lastMonth = moment().subtract(1, 'months');
            return toSrc === lastMonth.endOf('month').format('YYYY-MM-DD') &&
                fromSrc === lastMonth.startOf('month').format('YYYY-MM-DD');
        }

        function isLast3Months() {
            var today = moment();
            return toSrc === today.endOf('month').format('YYYY-MM-DD') &&
                fromSrc === today.subtract(3, 'months').startOf('month').format('YYYY-MM-DD');
        }

        function canSubmit() {
            return fromSrc !== from || toSrc !== to;
        }

        function submit() {
            $('body').addClass('is-loading');
            if (willBeToday()) {
                paramsURL.delete('from');
                paramsURL.delete('to');
            } else {
                paramsURL.set('from', from);
                paramsURL.set('to', to);
            }
            window.location.search = paramsURL.toString();
        }

        function updateValues() {
            $('[data-calendar-filter-action=from] [data-calendar-filter-action-label]', $el).html(moment(getFrom()).format('YYYY-MM-DD'));
            $('[data-calendar-filter-action=to] [data-calendar-filter-action-label]', $el).html(moment(getTo()).format('YYYY-MM-DD'));

            if (canSubmit()) {
                $('[data-calendar-filter-action=filter]').removeClass('button--is-disabled');
            } else {
                $('[data-calendar-filter-action=filter]').addClass('button--is-disabled');
            }
        }

        var dateFrom = moment().format('YYYY-MM-DD');
        if (paramsURL.has('from')) {
            var date = moment(paramsURL.get('from'));
            if (date.isValid()) {
                dateFrom = date.format('YYYY-MM-DD')
            }
        }
        fromSrc = dateFrom;
        from = dateFrom;

        var dateTo = moment().format('YYYY-MM-DD');
        if (paramsURL.has('to')) {
            var date = moment(paramsURL.get('to'));
            if (date.isValid()) {
                dateTo = date.format('YYYY-MM-DD')
            }
        }
        toSrc = dateTo;
        to = dateTo;

        updateValues();

        if (isToday()) {
            $label.html($el.data('labelToday'));
        } else if (isYesterday()) {
            $label.html($el.data('labelYesterday'));
        } else if (isSameDay()) {
            $label.html(moment(getTo()).format('MMM D'));
        } else if (isThisMonth()) {
            // $label.html($el.data('labelThisMonth'));
            $label.html([
                moment(getFrom()).format('MMM D'),
                moment(getTo()).format('MMM D')
            ].join(' - '));
        } else if (isLastMonth()) {
            // $label.html($el.data('labelLastMonth'));
            $label.html([
                moment(getFrom()).format('MMM D'),
                moment(getTo()).format('MMM D')
            ].join(' - '));
        } else if (isLast3Months()) {
            // $label.html($el.data('labelLast3Months'));
            $label.html([
                moment(getFrom()).format('MMM D'),
                moment(getTo()).format('MMM D')
            ].join(' - '));
        } else {
            $label.html([
                moment(getFrom()).format('MMM D'),
                moment(getTo()).format('MMM D')
            ].join(' - '));
        }
    })
})